import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const CASE_NUMBER_PATTERN = /^\d{8}$/i;
export const PRICE_PATTERN = /^\d+(\.\d{1,2})?$/;
export const PHONE_NUMBER_PATTERN = /^\+[0-9\s]{1,15}$/;
export const PHONE_NUMBER_NO_SPACES_PATTERN = /^\+[0-9]{1,15}$/;
export const FLIGHT_NUMBER_PATTERN = /^[A-Za-z]{2}[0-9]{1,4}$/;
export const FLIGHT_NUMBER_PATTERN_WITHOUT_AIRLINE_CODE = /^[0-9]{1,4}$/;
export const PAYMENT_IFSC_BIK_PATTERN = /^[a-z0-9]{11}$/i;
export const PAYMENT_KPP_PATTERN = /^[a-z0-9]{9}$/i;
export const PAYMENT_INN_PATTERN = /^[a-z0-9]{10}$/i;
export const PAYMENT_NCC_PATTERN = /^[A-Za-z0-9]{3,24}$/;

export const atLeastOneRequired = (controls: string[]): ValidatorFn => {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const hasAtLeastOneValue = controls.some((control) => {
      return !!formGroup.get(control).value;
    });
    return hasAtLeastOneValue ? null : { atLeastOneRequired: true };
  };
};
